import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/packages/contentful/components/content/index.tsx")